import {Component, OnInit, Input, ViewChild} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {SettingsSecurityService} from "./settings-security.service";
import {SharedService} from "../../shared/shared.service";
import {DtoSecurityItem} from "./models/DtoSecurityItem";
import {DtoSecurityBaseItems} from "./models/DtoSecurityBaseItems";

@Component({
    selector: 'security-authorisation',
    template: require('./security-authorisation.component.html'),
    styles: [require('./security-authorisation.component.css')]
})
@AutoUnsubscribe()

export class SecurityAuthorisationComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() type: number;
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;

    columnDefinition: ColumnDefinition[] = [
        {
            key: 'hasAccess',
            label: 'Authorisatie',
            type: 'boolean',
            width: '120px',
            enabled: true
        },
        {
            key: 'description',
            label: 'Soort medewerker',
            type: 'string',
            width: '*'
        }
    ];
    form: FormGroup;
    authorisationItems: Array<{ text: string, value: number }> = [
        { text: "Geen", value: 0 },
        { text: "Soort medewerker", value: 1 }
    ];
    dtoObject: DtoSecurityItem;
    baseItems: DtoSecurityBaseItems;
    showGrid: boolean;

    constructor(private fb: FormBuilder,
                private ds: SettingsSecurityService,
                private ss: SharedService) { }

    ngOnInit() {
        this.form = this.fb.group({
            useAuthorisation: null
        });

        this.form.get('useAuthorisation').valueChanges.subscribe(newVal => {
            if (newVal == 1) {
                this.showGrid = true;
                this.showGridData();
            } else {
                this.showGrid = false;
            }
        });


        this.ds.getSecurityItemByType(this.type)
            .subscribe(response => {
                this.dtoObject = response;
                if (this.dtoObject.employeeTypes && this.dtoObject.employeeTypes != '') {
                    this.form.patchValue({['useAuthorisation']: 1});
                } else {
                    this.form.patchValue({['useAuthorisation']: 0});
                }
            });
    }

    showGridData() {
        this.ds.getSecurityBaseItems(false).subscribe(res => {
            this.baseItems = res;
            this.setAuthorisationIds();
            this.grid.showData(this.baseItems.employeeKinds);
        });
    }

    getAuthorisationIds() {
        this.dtoObject.employeeTypes = '';
        if (this.showGrid) {
            this.grid.getData().forEach(item => {
                if (item.hasAccess) {
                    if (this.dtoObject.employeeTypes == '') {
                        this.dtoObject.employeeTypes = item.id.toString();
                    } else {
                        this.dtoObject.employeeTypes += ',' + item.id.toString();
                    }
                }
            });
        }
    }

    setAuthorisationIds() {
        let ids: string[] = [];
        if (this.dtoObject.employeeTypes) {
            ids = this.dtoObject.employeeTypes.split(',');
        }
        this.baseItems.employeeKinds.forEach(item => {
            item.hasAccess = ids.some((id) => { return id == item.id.toString()});
        });
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.getAuthorisationIds();
        this.ds.saveSecurityItem(this.dtoObject)
            .subscribe(response => {
                if (!response.hasError) {
                    this.closeWindow(true);
                }
                else {
                    this.ss.message(response.errorMessage);
                }
            });
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-security/security-authorisation.component.ts